import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { usePermissions } from '../../../context/PermissionsContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  module?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, module }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { hasModuleAccess, isPermissionsLoaded } = usePermissions();
  const location = useLocation();

  if (isLoading || (isAuthenticated && !isPermissionsLoaded)) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
        <div>Cargando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (module && !hasModuleAccess(module)) {
    return <Navigate to="/no-autorizado" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
